import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReservationContainerComponent } from '@app/_components/reservation/components/reservation/reservation-container/reservation-container.component';

@Component({
    selector: 'app-occupancy-dashboard',
    templateUrl: './occupancy-dashboard.component.html',
    styleUrls: ['./occupancy-dashboard.component.css'],
    providers: [MessageService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    standalone: false
})
export class OccupancyDashboardComponent implements OnInit {

  @Input() showSearchUI = true;
 	bizDevApis: any = [];
	propertyDevelopments: any = [];
	reservationArray: any[] = [];
	tempArray: any[]=[];

	constructor(
		public messageService: MessageService,
		public router: Router,
		private dialog: MatDialog,
		public reportService: ReportService) { }


	// forms
	formLoading = false;
	columnApi: ColumnApi;

	// to hold the current search
	currentSearchForm: any;
	selectedDateRange: any = 0;
	searchedCheckInDate: Date;
	searchedCheckOutDate: Date;
	
	reservations: any[];
	vacancies: any[];
	reservationsTotalsByDay: any[];
	reservationsTotalsByMonth: any[];
	reservationsTotalsByYear: any[];
	
	//Column array to display header on table and find propeties with field name
	columns: any[] = [
		{ field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'developmentName', header: 'Development Name', width: 'auto' },
		{ field: 'viewName', header: 'View', width: 'auto' },
		{ field: 'bedrooms', header: 'Bedrooms', width: 'auto' },
	];

	dateColumns: any[] = [];
	monthColumns: any[] = [];

	ngOnInit(): void {

	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.generateDateColumns();
		this.runReservationRevenueReport(searchForm);
	}

	/**
	 * Create the column header dynamically based on selected date range for each day
	 */
	generateDateColumns() {
		this.dateColumns = [];
		this.monthColumns = [];

		var endDate = new Date(this.currentSearchForm.endDate); 
		endDate.setDate(endDate.getDate() + 7);
		var startDate = new Date(this.currentSearchForm.startDate);
		startDate.setHours(0,0,0,0);
		startDate.setDate(startDate.getDate() - 7);

		var dayCount = 0;
		var prevMonth = null;
		//increment day one by one and add object to monthColumns array
		for(var dt=startDate; dt<=endDate; dt.setDate(dt.getDate()+1)){
			this.dateColumns.push({ date: dt.getDate(), width: 'auto', dateObj: dt.getTime() });
			if(prevMonth == null) {
				prevMonth = dt.getMonth();
				this.monthColumns.push({ month: new Date (dt), colspan: dayCount });
			} else {
				if(prevMonth != dt.getMonth()) {
					this.monthColumns[this.monthColumns.length - 1].colspan = dayCount;
					dayCount = 0;
					this.monthColumns.push({ month: new Date (dt), colspan: dayCount });
					prevMonth = dt.getMonth();
				}
				 else {
					this.monthColumns[this.monthColumns.length - 1].colspan = dayCount;
				}
			}
			dayCount = dayCount + 1;
		}
	}

	//Convert long amount to USD currency with two fractional digit
	currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return inrFormat.format(params);
	}

	/**
	 * Map reservation records with dates to show the booked reservations
	 * @param reservations 
	 * @param dateColumns 
	 */
	mapReservationWithDates(reservations: any, dateColumns) {
		reservations.forEach(reservation => {
			var reservationDates = [];
			dateColumns.forEach(dateColumn => {
				var dateMatched : boolean = false;
				var date = new Date(dateColumn.dateObj);
				reservation.dates.forEach(resDate => {
				var checkInDate = new Date(resDate.checkInDate);
				var checkOutDate = new Date(resDate.checkOutDate);
				this.setDateToMidNight(checkInDate);
				this.setDateToMidNight(checkOutDate);
				this.setDateToMidNight(date);
				this.setDateToMidNight(this.searchedCheckInDate);
				this.setDateToMidNight(this.searchedCheckOutDate);
				if(date >= checkInDate && date < checkOutDate && !dateMatched) {
					dateMatched = true; //Avoid duplicate reservation with same checkIn and checkOut
					var bookStatus: string = 'NAO'; //Not Available Outside Range
					if(date >= this.searchedCheckInDate && date <= this.searchedCheckOutDate) {
						bookStatus = 'NAI'; //Not Available Inside Range
					}
					var reservationDate = {
						bookStatus: bookStatus,
						revRoomRateNetTTL: this.currencyCellRendererUSD(reservation.revRoomRateNetTTL),
						revRoomRateNetPNT: this.currencyCellRendererUSD(reservation.revRoomRateNetPNT),
						date: date,
						reservationId: reservation.reservationId,
						reservation: reservation
					}
					reservationDates.push(reservationDate);
				} 
				});
				//If reservation not available then print red colour with no data message
				if(!dateMatched) {
					var vacancyDate = {
						bookStatus: '2', // 2 - No record
						revRoomRateNetPNT: '',
						date: date
					}
					reservationDates.push(vacancyDate);
				}
			});
			console.log(reservationDates);
			reservation.reservationDates = reservationDates;
		});
	}

	/**
	 * Map the table dates with available occupancy to show the availability
	 * @param reservations 
	 * @param dateColumns 
	 * @param vacancies 
	 */
	mapVacancyWithDates(reservations:any, dateColumns, vacancies: any) {
		if(vacancies) {
				vacancies.forEach(vacancy => {
					var vacancyDates = [];
					dateColumns.forEach(dateColumn => { //loop through all the dates
						var date = new Date(dateColumn.dateObj);
						var reservationFound = false;
						var vacancyFound = false;
						reservations.forEach(reservation => { //First print the reservations
							if(!reservationFound && reservation.shortTermRentalId == vacancy.shortTermRentalId) {
								reservation.reservationDates.forEach(reservationDate => {
									var dateObj = new Date(date);
									var reservationDateObj = new Date(reservationDate.date);
									if(reservationDateObj.getTime() == dateObj.getTime() && reservationDate.bookStatus != "2") { // 2 is for no data in reservation and vacancy. We will override book status 2 if vacancy found in any of object
										vacancyDates.push(reservationDate);
										reservationFound = true;
										return;
									}
								});
							}
						});
						//If property is not reserved then check for vacancy
						if(!reservationFound) {
						var checkInDate = new Date(vacancy.checkInDate);
						var checkOutDate = new Date(vacancy.checkOutDate);
						this.setDateToMidNight(checkInDate);
						this.setDateToMidNight(checkOutDate);
						this.setDateToMidNight(date);
						this.setDateToMidNight(this.searchedCheckInDate);
						this.setDateToMidNight(this.searchedCheckOutDate);
						if(date >= checkInDate && date <= checkOutDate) {
							var bookStatus: string = 'AOR'; //Available Outside Range
							if(date >= this.searchedCheckInDate && date <= this.searchedCheckOutDate) {
								bookStatus = 'AIR'; //Available Inside Range
							}
							var vacancyDate = {
								bookStatus: bookStatus,
								revRoomRateNetPNT: this.currencyCellRendererUSD(vacancy.nightlyRatePNT),
								date: date
							}
							vacancyDates.push(vacancyDate);
							vacancyFound = true;
						}
						}
						//If reservation and vacancy both not available then print red colour with not data message
						if(!reservationFound && !vacancyFound) {
							var vacancyDate = {
								bookStatus: '2', // 2 - No record
								revRoomRateNetPNT: '',
								date: date
							}
							vacancyDates.push(vacancyDate);
						}
					});
					var foundProperty = false;
					//add vacancy dates to reservation array
					reservations.forEach(reservation => {
						if(!foundProperty && reservation.shortTermRentalId == vacancy.shortTermRentalId) {
							foundProperty = true;
							reservation.reservationDates = vacancyDates;
						}
					});
					//If property not reserved then create new object and add to reservation as we loop by reservations in html table
					if(!foundProperty) {
						var availableReservation = {
							propertyCode : vacancy.propertyCode,
							developmentName : vacancy.developmentName,
							viewName : vacancy.viewId,
							numBedrooms : vacancy.numBedrooms,
							reservationDates : []
						};
						availableReservation.reservationDates = vacancyDates;
						reservations.push(availableReservation);
					}
				});
		}
	}

	/**
	 * Set the specified date hours to 12:00 A.M
	 */
	setDateToMidNight(date: Date) {
		date.setHours(0,0,0,0);
	}
	
	/**
	 * Get the reservations for selected dates and filters
	 * @param searchForm 
	 */
	runReservationRevenueReport(searchForm) {
		try {
			var startDate = this.addLocalTimeToDateTime(new Date(searchForm.startDate));
			var endDate = this.addLocalTimeToDateTime(new Date(searchForm.endDate));
			this.searchedCheckInDate = new Date(startDate);
			this.searchedCheckOutDate = new Date(endDate);
			startDate.setDate(startDate.getDate() - 7); // Add 7 days prior to searched date
			endDate.setDate(endDate.getDate() + 8); // Add 8 days after searched date // Add one more day to checkout day to include user searched end date in reservation and vacancy
			searchForm.startDate = startDate;
			searchForm.endDate = endDate;
			this.formLoading = true;
			this.reservations = []; // First empty the reservation array when user click search
			this.vacancies = []; // First empty the vacancy array when user click search
			let reservationSeacrhRequest = Object.assign({}, searchForm); ; // Copy search form to reservationSeacrhRequest to separate request for reservation
			reservationSeacrhRequest.reservationStatusList = this.reportService.activeReservations; // Fetch only active reservations
			this.reportService.reservationRevenueReport(reservationSeacrhRequest)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));

						this.reservations = res.data.resRevenues.resRevMaster;
						this.mergeMultipleReservationForSameProperty();
						this.reservations = this.reservationArray;
						this.reservationsTotalsByDay = res.data.resRevenues.resRevByDay;
						this.reservationsTotalsByMonth = res.data.resRevenues.resSalesTotalByMonth;
						this.reservationsTotalsByYear = res.data.resRevenues.resSalesTotalByYear;
						//Get the reservations
						this.mapReservationWithDates(this.reservations, this.dateColumns);
						//Get the available occupancy
						this.runOccupancyReport(searchForm);
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { 
						// this.formLoading = false; 
					});

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	/**
	 * Merging multiple reservations for same property
	 */
	mergeMultipleReservationForSameProperty() {
		this.reservationArray = []; //Start with empty every time API called.
		this.tempArray = [];
		let reservationObjs = this.reservations.map((nextReservation) => {
			let index = this.reservationArray.findIndex(x => x.propertyCode === nextReservation.propertyCode);
			//Index is not -1 if more than one reservation for same property
			if(index != -1){
				//Check for conflict in dates. 
				this.reservationArray[index].dates.forEach(prevReservation => {
					if(new Date(prevReservation.checkOutDate) < new Date(nextReservation.checkInDate)
					|| new Date(prevReservation.checkInDate) > new Date(nextReservation.checkOutDate)) {
						let dates = {
							checkInDate: nextReservation.checkInDate,
							checkOutDate: nextReservation.checkOutDate
						}
						this.reservationArray[index].dates.push(dates);
					}
				});
			}
			else{
				//Single reservation of property
				let dates = {
					checkInDate: nextReservation.checkInDate,
					checkOutDate: nextReservation.checkOutDate
				}
				this.tempArray.push(dates);
				nextReservation.dates = this.tempArray;
				this.reservationArray.push(nextReservation);
				this.tempArray = [];
			}
		});
	}

	//Get available occupancy (Vacancy) records
	runOccupancyReport(searchForm) {
		try {
			this.formLoading = true;
			this.reportService.occupancyReport(searchForm)
				.subscribe(
					res => {
						console.log('runOccupancyReport SUCCESS: ' + JSON.stringify(res));

						this.vacancies = res.data.occupancy.occupancyAPIs;
						//Merge available occupancy with reservation list object
						this.mapVacancyWithDates(this.reservations, this.dateColumns, this.vacancies);
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runOccupancyReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runOccupancyReport' });
		}
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime 
	 * @returns 
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	ngAfterViewInit(): void {
	}
	
	/*********
	* Open reservation screen
	*
	*/
	showReservation(reservationId: any, reservation: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie reservationId: this.reservationId,
		dialogConfig.data = {
			reservationId: reservationId,
			reservation: reservation,
			showCloseButton: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationContainerComponent, dialogConfig);
	}

}
